<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <LfpEventPicker
            v-if="manager.lfp || teatro.sga"
            :evento="localData"
            :sga="teatro.sga ? true : false"
            v-on:selected="selectedOption => {
                teatro.sga ? localData.sga_id = selectedOption.id : localData.lfp_id = selectedOption.id;
                if(teatro.sga) {
                    setSgaData(selectedOption);
                }
                localData.solicitar_datos = true
            }"
        />
        <SgaProductPicker
            v-if="localData.sga_id"
            :key="localData.sga_id"
            :sga_event_id="localData.sga_id"
            v-on:selected="selectedOption => {
                localData.sga_product_id = selectedOption.id;
            }"
        />


        <div class="row" v-if="!loadingData">
            <div class="col-12 col-lg-6">
                <FormInput label="Título" type="text" name="titulo" data-cy="titulo" id="titulo" rules="required" v-model="localData.name" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Subtítulo" type="text" name="artista" id="artista" v-model="localData.author" />
            </div>
            <div class="col-12 col-lg-4" v-if="manager.tipo == 1">
                <div class="form-group" id="equipo_local">
                    <label for="equipo_local">Equipo local</label>
                    <multiselect
                        v-model="localData.equipo_local_id"
                        placeholder="Equipo local"
                        label="nombre"
                        track-by="id"
                        :options="clubes"
                        :multiple="false"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-4" v-if="manager.tipo == 1">
                <div class="form-group" id="equipo_visitante">
                    <label for="equipo_visitante">Equipo visitante</label>
                    <multiselect
                        v-model="localData.equipo_visitante_id"
                        placeholder="Equipo visitante"
                        label="nombre"
                        track-by="id"
                        :options="clubes"
                        :multiple="false"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-4" v-if="manager.tipo == 1">
                <div class="form-group" id="division">
                    <label for="division">Competición</label>
                    <multiselect
                        v-model="localData.division_id"
                        placeholder="Competición"
                        label="nombre"
                        track-by="id"
                        :options="divisiones"
                        :multiple="false"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="form-group">
                    <label for="recinto">¿Tiene plano/recinto?</label>
                    <select v-model="localData.recinto" id="recinto" name="tiene_recinto" class="form-control" @change="setRecinto()">
                        <option value="false">No</option>
                        <option value="true">Si</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="form-group">
                    <label for="estado">Estado</label>
                    <multiselect
                        v-model="localData.status"
                        placeholder="Estado"
                        label="nombre"
                        track-by="id"
                        :options="estados"
                        :multiple="false"
                        :allowEmpty="false"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <MonedaPicker :moneda="localData.moneda" v-on:selected="selectedOption => { localData.moneda = selectedOption.code }"/>
            </div>
            <div class="col-12 col-lg-12" v-show="localData.recinto == 'true'">
                <div class="form-group">
                    <label for="recinto">Debe seleccionar el recinto, para poder publicarlo con numeración de butacas.</label>
                    <multiselect
                        name="recinto"
                        v-model="localData.place_obj"
                        placeholder="Seleccione el recinto"
                        label="name"
                        track-by="id"
                        :options="recintos"
                        :multiple="false"
                        @select="changeAddress"
                    />
                </div>
            </div>
            <div class="col-12">
                <div v-if="loadingTags" class="my-5">
                    <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div v-else-if="tags?.length" class="form-group">
                    <label for="eventos">Etiquetas</label>
                    <multiselect
                        v-model="localData.tags_seleccionadas"
                        placeholder="Selecciona las etiquetas que quieras"
                        label="name"
                        track-by="id"
                        :options="tags"
                        :multiple="true"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Descripcion</label>

                    <CkEditorComponent v-model="localData.synopsis"/>
                </div>
            </div>
            <div class="col-12 col-lg-12" v-if="direccion">
                <FormInput label="Dirección" type="text" name="direccion" id="direccion" rules="required" v-model="localData.address" />
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <Provincias
                        :provincia="localData.provincia"
                        :errors="errors"
                        @selected="selectedOption => { localData.provincia_id = selectedOption }"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <Locations
                        :provincia="localData.provincia_id"
                        :location_id="localData.location_id"
                        :errors="errors"
                        @selected="selectedOption => { localData.location_id = selectedOption?.id }"
                        :forceMultiselect="true"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="start_event_date">Fecha de inicio <small>(DÍA DE COMIENZO)</small></label>
                    <datetime
                        :min-datetime="new Date().toISOString()"
                        v-model="localData.start_event_date"
                        input-class="form-control"
                        type="datetime"
                        input-id="start_event_date"
                        :value-zone="this.config.TIMEZONE"
                        @input="clearFecha"
                    />
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="end_event_date">Fecha de fin <small>(DÍA DE FINAL)</small></label>
                    <datetime
                        :disabled="localData.start_event_date == ''"
                        :min-datetime="localData.start_event_date"
                        v-model="localData.end_event_date"
                        input-class="form-control"
                        type="datetime"
                        input-id="end_event_date"
                        :value-zone="this.config.TIMEZONE"
                    />
                </div>
            </div>
            <div class="col-12">
                <label for="imagen">Imagen del evento <b>(MEDIDAS: 1020X340 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB)</b> <small>(SOLO SI SE TRATA DE UN EVENTO SIN EQUIPOS)</small></label>
                <Dropzone
                    v-if="url"
                    :url="url"
                    :height="340"
                    :width="1020"
                    @success="imagenSubida"
                />
            </div>
            <div class="col-12 col-lg-6 mt-3">
                <div class="form-group">
                    <label for="nombre">Meta título* <small>(Es el título que se mostrará en los buscadores. Máximo 80 caracteres.)</small></label>
                    <ValidationProvider name="meta_title" rules="max:80" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="meta_title" placeholder="Meta título" v-model="localData.meta_title"/>
                        <span class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-lg-6 mt-3">
                <div class="form-group">
                    <label for="meta_descripcion">Meta descripción* <small>(Es la descripción que se mostrará en los buscadores. Máximo 160 caracteres.)</small></label>
                    <ValidationProvider name="meta_description" rules="max:160" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="meta_description" placeholder="Meta descripción" v-model="localData.meta_description"/>
                        <span class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="form-group">
                    <label for="youtube">Id del video en Youtube</label>
                    <ValidationProvider name="youtube" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="youtube" placeholder="Id del video en Youtube" v-model="localData.youtube_id"/>
                        <span class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-lg-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Condiciones para Acreditaciones</label>
                    <CkEditorComponent v-model="localData.condiciones_acreditaciones"/>
                </div>
            </div>
            <div class="col-12 col-lg-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Política de menores</label>
                    <ValidationProvider name="underage_policy">
                        <CkEditorComponent v-model="localData.underage_policy"/>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Número máximo de asientos por pedido</label>
                    <ValidationProvider name="n_max_asientos_pedido" v-slot="{ errors }">
                        <input type="number" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="n_max_asientos_pedido" placeholder="N max de asientos por pedido" v-model="localData.n_max_asientos"/>
                        <span class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_permitir_liberacion_asientos" v-model="localData.permitir_liberacion_asientos"/>
                    <label for="checkbox_permitir_liberacion_asientos" class="custom-control-label pt-1">
                        Permitir la liberación de asientos
                    </label>
                </div>
            </div>
            <b-col cols="12" v-if="localData.permitir_liberacion_asientos">
                <b-row>
                    <b-col lg="6" md="12">
                        <div class="form_control">
                            <label class="mt-3" for="importe_monedero_abonado">
                                Importe integro que se le sumará al abonado en el monedero al liberar su asiento
                            </label>
                            <input
                                type="decimal"
                                name="importe_monedero_abonado"
                                id="importe-monedero-abonado"
                                placeholder="Introduce un importe"
                                v-model="localData.importe_monedero_abonado"
                                @input="localData.porcentaje_monedero_abonado = null"
                            />
                        </div>
                    </b-col>
                    <b-col lg="6" md="12">
                        <div class="form_control">
                            <label class="mt-3" for="porcentaje_monedero_abonado">
                                Porcentaje sobre el importe de venta que se le sumará al abonado en el monedero al liberar su asiento
                            </label>
                            <input
                                type="decimal"
                                name="porcentaje_monedero_abonado"
                                id="porcentaje-monedero-abonado"
                                placeholder="Introduce un porcentaje"
                                v-model="localData.porcentaje_monedero_abonado"
                                @input="localData.importe_monedero_abonado = null"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <template v-if="! localData.experiencia">
                <div class="col-12 mt-3">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="localData.cerrar_butacas_abonados"/>
                        <label for="customCheckbox2" class="custom-control-label pt-1">
                            Cerrar las butacas de los abonados <small>(Se cierran las butacas de los abonados, ningún usuario pueda elegir la localidad del abonado. Solo el abonado podrá adquirir la localidad.)</small>
                        </label>
                    </div>
                </div>
                <template v-if="localData.cerrar_butacas_abonados">
                    <div class="col-12 mt-3 ml-5">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="customCheckbox22" v-model="localData.cerrar_butacas_abonados_no_confirmados"/>
                            <label for="customCheckbox22" class="custom-control-label pt-1">
                                Cerrar las butacas de los abonados reservados <small>(No se puede activar si "Cerrar las butacas de los abonados" no estaba ya marcado)</small>
                            </label>
                        </div>
                    </div>
                    <div v-if="tipos?.length" class="col-12">
                        <DescuentosAbonados :evento="localData" :tipos="tipos" @updateEvento="(datosEvento) => { localData = { ...datosEvento } }" />
                    </div>
                </template>
            </template>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox23" v-model="localData.venta_online_cerrada"/>
                    <label for="customCheckbox23" class="custom-control-label pt-1">
                        Cerrar venta online
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3" v-if="localData.venta_online_cerrada">
                <div class="form-group">
                    <label for="fecha_apertura_de_venta">Fecha de apertura de venta</label>
                    <input
                        v-model="localData.cuenta_atras"
                        class="form-control"
                        type="datetime-local"
                        id="fecha_apertura_de_venta"
                    />
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox24" v-model="localData.venta_online_cerrada_definitiva"/>
                    <label for="customCheckbox24" class="custom-control-label pt-1">
                        CERRAR VENTA ONLINE (Definitivo)
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="entradas_agotadas_online" v-model="localData.entradas_agotadas_online"/>
                    <label for="entradas_agotadas_online" class="custom-control-label pt-1">
                        Entradas agotadas online (Al marcar este check saldrán entradas agotadas en la venta online pero se seguirá pudiendo comprar en taquilla)
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox25" v-model="localData.solicitar_datos" :disabled="localData.lfp_id"/>
                    <label for="customCheckbox25" class="custom-control-label pt-1">
                        Entradas nominativas
                    </label>
                </div>
            </div>
            <div class="col-12 mt-2" v-if="localData.solicitar_datos">
                <div class="form-group">
                    <label for="limite_tiempo_cambiar_nombre_entrada">Tiempo límite para que el usuario pueda cambiar los datos de su entrada desde el perfil antes de la fecha de inicio del evento.</label>
                    <multiselect
                        style="z-index: 9999;"
                        v-model="localData.limite_tiempo_cambiar_nombre_entrada"
                        placeholder="Seleccione el tiempo límite"
                        label="nombre"
                        track-by="id"
                        id="limite_tiempo_cambiar_nombre_entrada"
                        :options="limites_tiempo"
                    />
                </div>
            </div>
            <div class="col-12 mt-3" v-if="! localData.experiencia">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox5" v-model="localData.solo_abonados"/>
                    <label for="customCheckbox5" class="custom-control-label pt-1">
                        Solo venta para abonados. <small>(Solo podrán realizar la compra los Abonados, en caso de no ser abonado el usuario no abonado no podrá acceder a la compra. Esta opción desactivada implica que se abre la venta a usuarios no abonados).</small>
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3" v-if="! localData.experiencia">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox3" v-model="localData.descuento_abonado"/>
                    <label for="customCheckbox3" class="custom-control-label pt-1">
                        Activar día del abonado <small>(El abonado tendrá que activar / adquirir su entrada tanto online como física. Esta modalidad es válida para entradas desde 0.00€. Si el abono no se activa, este no podrá acceder al recinto. )</small>
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox" v-if="! localData.experiencia">
                    <input class="custom-control-input" type="checkbox" id="customCheckboxAmigoAbonado" v-model="localData.amigo_abonado"/>
                    <label for="customCheckboxAmigoAbonado" class="custom-control-label pt-1">
                        Activar descuentos para amig@s de los abonad@s
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox" v-if="! localData.experiencia">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox4" v-model="localData.seccion"/>
                    <label for="customCheckbox4" class="custom-control-label pt-1">
                        El abonado solo podrá adquirir su entrada en la zona correspondiente al Abono. No podrá adquirir entradas en otras zonas diferentes al abono.
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox" v-if="! localData.experiencia">
                    <input class="custom-control-input" type="checkbox" id="checkbox_forzar_adyacentes" v-model="localData.forzar_adyacentes"/>
                    <label for="checkbox_forzar_adyacentes" class="custom-control-label pt-1">
                        Forzar la compra de butacas adyacentes por secciones completas
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_redireccion_otra_web" v-model="localData.activar_enlace_redireccion"/>
                    <label for="checkbox_redireccion_otra_web" class="custom-control-label pt-1">
                        Añadir redirección a otra web en el botón de compra
                    </label>
                </div>

                <div v-if="localData.activar_enlace_redireccion" class="form_control">
                    <label class="mt-3" for="redireccion_otra_web">
                        Introduce una url
                    </label>
                    <input type="text" name="redireccion_otra_web" id="redirigir-otra-web" placeholder="Introduce una url" v-model="localData.enlace_redireccion"/>
                </div>
            </div>

            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="comprobacion_butacas" v-model="localData.comprobacion_butacas"/>
                    <label for="comprobacion_butacas" class="custom-control-label pt-1">
                        Comprobar huecos entre butacas
                    </label>
                </div>
            </div>

            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_compra_unica" v-model="localData.compra_unica"/>
                    <label for="checkbox_compra_unica" class="custom-control-label pt-1">
                        Compra única <small>(Cuando hay cola solo dejara comprar una vez luego le llevara a la cola otra vez)</small>
                    </label>
                </div>
            </div>

            <div class="col-12 mt-3" v-if="localData.recinto">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="tiene_plazas_extra" v-model="localData.tiene_plazas_extra"/>
                    <label for="tiene_plazas_extra" class="custom-control-label pt-1">
                        Tiene plazas extra
                    </label>
                </div>
                <template v-if="localData.tiene_plazas_extra">
                    <hr/>
                    <FormInput
                        label="Texto del producto extra"
                        type="text"
                        name="texto_producto_extra"
                        id="texto_producto_extra"
                        rules="required"
                        v-model="localData.texto_producto_extra"
                    />
                </template>
            </div>

            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="compra_privada" v-model="localData.compra_privada"/>
                    <label for="compra_privada" class="custom-control-label pt-1">
                        Compra privada
                    </label>
                </div>
            </div>

            <div class="col-12 mt-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="calendario" v-model="localData.calendario"/>
                    <label for="calendario" class="custom-control-label pt-1">
                        Evento tipo calendario
                    </label>
                </div>
            </div>

            <template v-if="localData.descuento_abonado && ! localData.experiencia">
                <div class="col-12 mt-3">
                    <div class="form-group">
                        <label for="fecha_envio">Tiempo limite para el día del abonado <small>(Una vez transcurrido el día y la hora indicada, se liberan los asientos de los abonados y cualquier usuario podrá adquirir la butaca liberada. El abonado si accede y su butaca está ocupada, podrá elegir otra butaca.)</small></label>
                        <datetime
                            v-model="localData.limite_dia_abonado"
                            input-class="form-control"
                            type="datetime"
                            input-id="limite_dia_abonado"
                            :value-zone="this.config.TIMEZONE"
                        />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="provincias">Tipos de abonos que pueden comprar entrada <small>(Día del abonado - Si no asignas ningún tipo de abono se permitirá la compra a todos los tipos de abono)</small></label>
                        <multiselect
                            v-model="localData.tipos_abonos_ids"
                            placeholder="Tipos de abonos"
                            label="descripcion"
                            track-by="id"
                            :options="tipos"
                            :multiple="true"
                        />
                    </div>
                </div>
            </template>

            <template v-if="localData.descuento_abonado || localData.amigo_abonado">
                <div class="col-12" >
                    <hr/>
                    <label class="text-danger">Indica el número de abonados que sólo pueden disponer de la compra de entradas, en caso de no indicar ninguna numeración se aplicará por defecto a TODOS LOS ABONADOS. <small>(Día del abonado y Amig@)</small> </label>
                    <div class="form-group">
                        <label for="fecha_envio">Desde</label>
                        <input type="number" class="form-control" id="titulo" placeholder="Desde" v-model="localData.abonado_desde"/>
                    </div>
                    <div class="form-group">
                        <label for="fecha_envio">Hasta</label>
                        <input type="number" class="form-control" id="titulo" placeholder="Hasta" v-model="localData.abonado_hasta"/>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="n_acompanantes_min">Número mínimo de acompañantes <small>(Día del abonado y Amig@)</small></label>
                        <input type="number" class="form-control" id="n_acompanantes_min" placeholder="Número mínimo de acompañantes" v-model="localData.n_acompanantes_min"/>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="n_acompanantes">Número máximo de acompañantes <small>(Día del abonado y Amig@)</small></label>
                        <input type="number" class="form-control" id="n_acompanantes" placeholder="Número máximo de acompañantes" v-model="localData.n_acompanantes"/>
                    </div>
                </div>
            </template>

            <div class="col-12" v-if="localData.descuento_abonado">
                <div class="form-group">
                    <label for="provincias">Tipos de abonos que pueden acceder al evento sin comprar entrada <small>(Día del abonado)</small></label>
                    <multiselect
                        v-model="localData.tipos_abonos_permitidos_ids"
                        placeholder="Tipos de abonos"
                        label="descripcion"
                        track-by="id"
                        :options="tipos"
                        :multiple="true"
                    />
                </div>
            </div>

            <template v-if="localData.amigo_abonado">
                <div class="col-12">
                    <div class="form-group">
                        <label for="provincias">Tipos de abonos no permitidos <small>(Amig@s de los abonad@s)</small></label>
                        <multiselect
                            v-model="localData.amigos_tipos_abonos_ids"
                            placeholder="Tipos de abonos"
                            label="descripcion"
                            track-by="id"
                            :options="tipos"
                            :multiple="true"
                        />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="provincias">Precios no permitidos <small>(Amig@s de los abonad@s)</small></label>
                        <multiselect
                            v-model="localData.amigos_descuentos_abonos_ids"
                            placeholder="Descuentos no permitidos"
                            label="descripcion"
                            track-by="id"
                            :options="descuentos"
                            :multiple="true"
                        />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="n_max_pedidos">Número máximo de pedidos</label>
                        <input type="number" class="form-control" id="n_max_pedidos" placeholder="Número máximo de pedidos" v-model="localData.n_max_pedidos"/>
                    </div>
                </div>
            </template>

            <div v-if="footer.tipo == config.TEATROS" class="col-12 mt-3">
                <hr/>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_evento_barra" v-model="localData.evento_barra"/>
                    <label for="checkbox_evento_barra" class="custom-control-label pt-1">
                        Evento barra
                    </label>
                </div>
            </div>
            <div v-if="footer.tipo == config.DEPORTES" class="col-12 mt-3">
                <hr/>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_evento_experiencia" v-model="localData.experiencia"/>
                    <label for="checkbox_evento_experiencia" class="custom-control-label pt-1">
                        Experiencia <small>(Este evento solo aparecerá en el apartado de experiencias)</small>
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <hr/>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_reserva_instalaciones" v-model="localData.reserva_instalaciones"/>
                    <label for="checkbox_reserva_instalaciones" class="custom-control-label pt-1">
                        Reserva de instalaciones
                    </label>
                </div>
            </div>
            <div v-if="teatro.invitaciones_para_abonados" class="col-12 mt-3">
                <hr/>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_invitaciones_para_abonados" v-model="localData.invitaciones_para_abonados"/>
                    <label for="checkbox_invitaciones_para_abonados" class="custom-control-label pt-1">
                        Activar invitaciones de abonados en este evento
                    </label>
                </div>
            </div>
            <div v-if="localData.reserva_instalaciones" class="col-12 col-lg-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Reglamento</label>
                    <ValidationProvider name="underage_policy">
                        <CkEditorComponent v-model="localData.reglamento"/>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mt-3">
                <hr/>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="checkbox_no_enviar_entradas" v-model="localData.no_enviar_entradas"/>
                    <label for="checkbox_no_enviar_entradas" class="custom-control-label pt-1">
                        Enviar entradas 72h antes del evento <small>(las entradas <b class="text-underline">NO</b> se enviarán antes de este plazo por ningún medio)</small>
                    </label>
                </div>
            </div>
            <b-col v-if="(localData.recinto == false || localData.recinto == 'false') && localData.start_event_date" cols="12" class="mt-3">
                <hr/>
                <div class="custom-control custom-checkbox mb-2">
                    <input class="custom-control-input" type="checkbox" id="entradas_otros_eventos" v-model="localData.entradas_compartidas"/>
                    <label for="entradas_otros_eventos" class="custom-control-label pt-1">
                        Permitir entradas de otros eventos
                    </label>
                </div>
                <div class="form-group" v-if="localData.entradas_compartidas">
                    <template v-if="eventos.length && !loadingEventos">
                        <label for="eventos">Selecciona los eventos de los que quieres cargar las entradas</label>
                        <multiselect
                            v-model="localData.eventos_compartidos"
                            placeholder="Selecciona los eventos"
                            label="name"
                            track-by="id"
                            :options="eventos"
                            :multiple="true"
                        />
                    </template>
                    <div class="spinner-border text-primary" role="status" v-else>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </b-col>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import Dropzone from '@/components/common/Dropzone';
    import Provincias from '@/components/common/forms/Provincias';
    import Locations from "../../common/forms/Locations";
    import LfpEventPicker from "./LfpEventPicker";
    import MonedaPicker from './MonedaPicker.vue'
    import SgaProductPicker from './SgaProductPicker';
    import DescuentosAbonados from './DescuentosAbonados.vue';

    export default {
        props: {
            evento: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public',
                clubes: [],
                divisiones: [],
                estados: [
                    {id: 0, nombre: 'Borrador'},
                    {id: 1, nombre: 'Publicado'},
                    {id: 3, nombre: 'Aplazado'},
                    {id: 2, nombre: 'Cancelado'},
                ],
                tipos: [],
                recintos: [],
                direccion: true,
                errors: [],
                provincia: null,
                eventos: [],
                limites_tiempo: [
                    {id: 1, nombre: '24 horas'},
                    {id: 2, nombre: '48 horas'},
                    {id: 3, nombre: '72 horas'}
                ],
                localData: {...this.evento, descuentos_abonados_no_cerrar_butacas_seleccionados: [], tipo_abono_no_cerrar_butacas: null, no_cerrar_butacas_combinaciones: [] },
                loadingData: false,
                loadingEventos: false,
                loadingTags: false,
                tags: []
            }
        },
        created() {
            this.getClubes();
            this.getDivisiones();
            this.getRecintos();
            this.getTipos();
            this.getTags();
            this.$nextTick(() => this.$refs.observer.reset());

            if(process.env.VUE_APP_TEST_APP == 1) {
                this.localData.test = 1;
            }

            if(this.localData.recinto) {
                this.localData.recinto = 'true';
            }

            if(!this.localData.place_id && this.$store.getters.getRecinto && !this.localData.entradas_compartidas) {
                this.localData.place_id = this.$store.getters.getRecinto.id;
            }

            if(this.localData.provincia) {
                this.localData.provincia_id = this.localData.provincia;
            }

            if(this.localData.equipo_visitante_id) {
                this.localData.equipo_visitante_id = this.localData.equipo_visitante;
            }

            if(this.localData.equipo_local_id) {
                this.localData.equipo_local_id = this.localData.equipo_local;
            }

            if(this.localData.division_id) {
                this.localData.division_id = this.localData.division;
            }

            if(this.localData.status) {
                let estadoIndex = this.estados.findIndex(estados => estados.id == this.localData.status);
                if(estadoIndex < 0) estadoIndex = 0;

                this.localData.status = this.estados[estadoIndex];
            } else {
                this.localData.status = this.estados[0];
            }

            if(!this.localData.address && !this.localData.entradas_compartidas) {
                this.localData.address = this.$store.getters.getRecinto.address;
            }

            if (this.localData.entradas_compartidas) {
                this.getEventos();
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            descuentos() {
                let descuentos = [];

                this.localData.amigos_tipos_abonos_ids.forEach(precio => {
                    precio.descuentos.forEach(descuento => {
                        descuentos.push(descuento);
                    });
                })

                return descuentos;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        watch: {
            'localData.entradas_compartidas'(newVal) {
                if (newVal) {
                    this.getEventos();
                }
            }
        },
        methods: {
            getEventos() {
                this.loadingEventos = true;

                const params = {
                    filters: {
                        to_select: true,
                        para_compartir: true,
                        fecha_maxima: this.localData.start_event_date
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias("back.events.index"), params).then(res => {
                    this.eventos = res.data.data;
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loadingEventos = false;
                });
            },
            changeAddress() {
                this.direccion = false;
                if (this.localData.place_obj?.address) {
                    this.localData.address = this.localData.place_obj.address;
                }
                this.$nextTick(() => this.direccion = true);
            },
            getTipos : function() {
                this.loading = true;
                const params = {
                    filters :  {
                        per_page: 9999,
                        page: 1,
                        search: '',
                        all: 1
                    },
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.tipos = res.data.data;
                    this.loading = false;
                });
            },
            getDivisiones() {
                this.$store.dispatch(this.config.getVuexAlias('select.divisiones')).then(res => {
                    this.divisiones = res.data;
                });
            },
            getClubes() {
                this.$store.dispatch(this.config.getVuexAlias('select.clubes')).then(res => {
                    this.clubes = res.data;
                });
            },
            getRecintos() {
                this.$store.dispatch(this.config.getVuexAlias('recintos.index')).then(res => {
                    this.recintos = res.data.data;
                });
            },
            imagenBorrada() {
                //this.evento.image = '';
            },
            imagenSubida(file, response) {
                this.localData.image = response;
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearEvento();
                }
            },
            crearEvento() {
                this.localData.status = this.localData.status.id;
                if (this.localData.limite_tiempo_cambiar_nombre_entrada) {
                    this.localData.limite_tiempo_cambiar_nombre_entrada = this.localData.limite_tiempo_cambiar_nombre_entrada.id;
                }
                if (!this.localData.venta_online_cerrada) {
                    this.localData.cuenta_atras = null;
                }
                if (this.localData.recinto === 'false' || this.localData.recinto === false) {
                    this.localData.place_obj = null;
                    this.localData.place_id = null;
                } else {
                    this.localData.entradas_compartidas = false;
                    this.localData.eventos_compartidos = [];
                }
                if (this.localData.experiencia) {
                    this.localData.lfp_id = null;
                }

                if (this.localData.no_cerrar_butacas_combinaciones?.length) {
                    this.localData.descuentos_abonados_no_cerrar_butacas = this.localData.no_cerrar_butacas_combinaciones.flatMap(c => c.descuentos.map(d => d.id));
                } else {
                    delete this.localData.descuentos_abonados_no_cerrar_butacas;
                }

                delete this.localData.descuentos_abonados_no_cerrar_butacas_seleccionados;
                delete this.localData.tipo_abono_no_cerrar_butacas;
                delete this.localData.no_cerrar_butacas_combinaciones;

                if (this.localData.tags_seleccionadas?.length) {
                    this.localData.tags = this.localData.tags_seleccionadas.map(tag => tag.id);
                } else {
                    this.localData.tags = [];
                }

                this.$emit('terminado', this.localData);
            },
            clearFecha() {
                if(new Date(this.localData.start_event_date) > new Date(this.localData.end_event_date)){
                    this.localData.end_event_date = '';
                }
            },
            setRecinto() {
                if (this.localData.recinto) {
                    this.localData.place_obj = this.recinto;
                }
            },
            setSgaData(data) {
                this.loadingData = true;
                this.localData.name = data.name;
                this.localData.author = data.season?.name;
                this.$nextTick(() => {
                    this.loadingData = false;
                });
            },
            getTags() {
                this.loadingTags = true;

                const params = {
                    filters: {
                        to_select: true
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('back.tags'), params).then(res => {
                    this.tags = res.data.data;
                })
                    .catch(() =>{
                        this.$toast.error('Error al cargar las etiquetas');
                    })
                    .finally(() => {
                        this.loadingTags = false;
                    });
            }
        },
        components: {
            LfpEventPicker,
            Locations,
            CkEditorComponent, Dropzone, Provincias, MonedaPicker, SgaProductPicker,
            DescuentosAbonados
        }
    }
</script>
